<template>
    <v-app v-cloak>
        <v-main>
            <router-view></router-view>
            <!-- <div v-if="showBtnAuth" id="chat-widget-container">
                <iframe id="lmpchat-widget" allow="clipboard-read; clipboard-write; autoplay; microphone *; camera *; display-capture *; picture-in-picture *; fullscreen *;" src="https://lmpchat.test/chat" name="chat-widget" title="LiveChat chat widget" scrolling="yes" style="width: 100%; height: 100%; min-height: 0px; min-width: 0px; margin: 0px; padding: 0px; background-image: none; background-position: 0% 0%; background-size: initial; background-attachment: scroll; background-origin: initial; background-clip: initial; background-color: rgba(0, 0, 0, 0); border-width: 0px; float: none; color-scheme: normal; position: absolute; inset: 0px; transition: none !important; display: block; visibility: visible;"></iframe>
            </div> -->
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: "app",
    data() {
        return {};
    },
    computed: {
        showBtnAuth() {
            return this.$store.getters["auth/isAuthenticated"];
        }
    },
    methods: {
        // iframeEvent(event) {
        //     if(event.origin !== 'https://lmpchat.test') return;

        //     if(event.data.message.popupState) {
        //         document.getElementById("chat-widget-container").style.width = "392px";
        //         document.getElementById("chat-widget-container").style.height = "714px";

        //         if(event.data.message.maximizeState) {
        //             document.getElementById("chat-widget-container").style.width = "100%";
        //             document.getElementById("chat-widget-container").style.height = "100%";
        //         } else {
        //             document.getElementById("chat-widget-container").style.width = "392px";
        //             document.getElementById("chat-widget-container").style.height = "714px";
        //         }
        //     } else {
        //         document.getElementById("chat-widget-container").style.width = "130px";
        //         document.getElementById("chat-widget-container").style.height = "130px";
        //     }
        // }
    },
    mounted() {
        // let top = this.$refs['dashboard'].offsetTop;
        // window.addEventListener("message", this.iframeEvent);
        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 500);
    },
    beforeDestroy () {
        // window.removeEventListener('message', this.iframeEvent)
    }
};
</script>

<style lang="scss">
[v-cloak], .v-cloak {
    display: none;
}
[v-cloak] > *, .v-cloak > * {
    display: none;
}
::v-deep .v-application--wrap {
    min-height: calc(100vh - 321px) !important;
}

#chat-widget-container {
    display: none !important;
    opacity: 1;
    visibility: visible;
    z-index: 2147483639;
    position: fixed;
    bottom: 0px;
    width: 130px;
    height: 130px;
    max-width: 100%;
    max-height: calc(100% + 0px);
    min-height: 0px;
    min-width: 0px;
    background-color: transparent;
    border: 0px;
    overflow: hidden;
    right: 0px;
    transition: none !important;
}

.v-application .v-btn+.v-btn {
    margin-left: 8px;
}
</style>
